// app/javascript/controllers/tom_select_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  // connect() {
  //   if (!this.element.tomselect) {
  //     this.initializeTomSelect()
  //   }
  // }

  connect() {
    // 1. Verificación estricta: Si TomSelect ya existe en este elemento, salir de inmediato
    if (this.element.tomselect || this.element.classList.contains('tomselected')) {
      console.log("tom-select: El elemento ya fue inicializado, saltando.");
      return;
    }

    // 2. Solo inicializar si no existe la instancia
    this.initializeTomSelect();
  }

  initializeTomSelect() {
    this.element.classList.remove("form-control")

    // FORZAR STRINGS: TomSelect internamente usa strings para los values.
    let initialLocked = []
    try {
      initialLocked = JSON.parse(this.element.dataset.tomSelectInitialValues || "[]")
    } catch (e) {
      console.error("tom-select: error parseando tomSelectInitialValues", e)
      initialLocked = []
    }
    initialLocked = initialLocked.map(String)
    const lockedValues = new Set(initialLocked)

    // debug: mostrar lo que llegó
    console.info("tom-select: initialLocked ->", initialLocked)

    const options = {
      plugins: {
        remove_button: { title: "Eliminar" }
      },
      create: false,
      sortField: { field: "text", direction: "desc" },

      render: {
        option: function (data, escape) {
          const recursos = data.recursos ? JSON.parse(data.recursos) : []
          const insumos = data.insumos ? JSON.parse(data.insumos) : []
          const equipamientos = data.equipamiento ? JSON.parse(data.equipamiento) : []

          const recursosText = recursos.length > 0
            ? recursos.map(r => `Especialidad: ${r[0] || "N/A"} - ${r[1]}hs - Cant: ${r[2]} - Por: ${r[3]}${r[4] ? " - " + r[4] : ""}`).join("\n")
            : "No hay recursos"

          const insumosText = insumos.length > 0
            ? insumos.map(i => `${i[2]} - Cant: ${i[1]} - Por: ${i[0]}`).join("\n")
            : "No hay insumos"

          const equipamientosText = equipamientos.length > 0
            ? equipamientos.map(e => `${e[0]}`).join("\n")
            : "No hay equipamiento"

          return `<div class="option" data-value="${escape(data.value)}" title="RECURSOS:\n${recursosText}\nINSUMOS:\n${insumosText}\nEQUIPAMIENTOS:\n${equipamientosText}">${escape(data.text)}</div>`
        }
      },

      /**
       * onInitialize: oculta la X y marca dataset.locked en los items
       */
      onInitialize: function () {
        const tom = this
        console.info("tom-select: onInitialize items ->", Object.keys(tom.items || {}))

        initialLocked.forEach(value => {
          const item = tom.getItem(value)
          if (item) {
            item.dataset.locked = "true"
            const removeBtn = item.querySelector(".remove")
            if (removeBtn) removeBtn.remove()
            // también agregar clase visual opcional
            item.classList.add("ts-item-locked")
            console.debug("tom-select: marcado locked item", value)
          }
        })

        // Fallback: prevenir eliminación por tecla (Backspace / Delete)
        if (tom.control_input) {
          tom.control_input.addEventListener("keydown", function (e) {
            if (e.key !== "Backspace" && e.key !== "Delete") return
            const selected = Object.keys(tom.items || {})
            if (selected.length === 0) return
            const anyLocked = selected.some(v => lockedValues.has(String(v)))
            if (anyLocked) {
              console.debug("tom-select: prevented key delete because locked present", selected)
              e.preventDefault()
              e.stopPropagation()
              return false
            }
          })
        }
      },

      /**
       * onItemRemove: hook que se ejecuta cuando se intenta remover con UI.
       * Retornar false cancela la eliminación.
       */
      onItemRemove: function (value) {
        console.debug("tom-select: onItemRemove ->", value)
        if (lockedValues.has(String(value))) {
          console.warn("tom-select: bloqueo onItemRemove para value", value)
          return false
        }
        return true
      },

      /**
       * onDelete: hook para cuando TomSelect intenta eliminar múltiple (keyboard).
       * Debe devolver lista de values permitidos a eliminar o false para cancelar.
       */
      onDelete: function (values) {
        console.debug("tom-select: onDelete ->", values)
        const allowed = values.filter(v => !lockedValues.has(String(v)))
        if (allowed.length === 0) {
          console.warn("tom-select: onDelete bloqueado, todos locked ->", values)
          return false
        }
        console.debug("tom-select: onDelete allowed ->", allowed)
        return allowed
      }
    }

    // Crear instancia y mantener referencia
    const instance = new TomSelect(this.element, options)

    // Override defensivo: interceptar removeItem para bloquear valores locked (compatibilidad versiones)
    try {
      const originalRemoveItem = instance.removeItem
      instance.removeItem = function (value, silent) {
        if (lockedValues.has(String(value))) {
          console.warn("tom-select: override removeItem bloqueado para", value)
          return false
        }
        return originalRemoveItem.call(this, value, silent)
      }
    } catch (e) {
      console.debug("tom-select: no se pudo override removeItem:", e)
    }

    // CONTINGENCIA: al submit del form, re-agregamos los locked values si desaparecieron
    // así no dependemos 100% de hooks (por si hay edge-case)
    const form = this.element.closest("form")
    if (form) {
      form.addEventListener("submit", (ev) => {
        try {
          const selected = Object.keys(instance.items || {}).map(String)
          const missing = initialLocked.filter(v => !selected.includes(String(v)))
          if (missing.length) {
            console.warn("tom-select: re-agregando locked values en submit ->", missing)
            missing.forEach(v => {
              // si no existe la option, la agregamos como option oculta
              if (!instance.options[v]) {
                instance.addOption({ value: v, text: v })
              }
              instance.addItem(String(v))
            })
          }
        } catch (err) {
          console.error("tom-select: error al re-agregar locked values en submit", err)
        }
      })
    }

    // Exponer instancia por si la querés debuggear en consola
    this.element._tomselect_instance = instance
  }

  refresh() {
    if (this.element.tomselect) {
      this.element.tomselect.destroy()
    }
    this.initializeTomSelect()
  }
}
